export const manualSectionTheme = {
  imageDescription: 'palette.tertiary.40',
  list: {
    dot: {
      bg: 'palette.primary.40',
      borderRadius: '30px',
    },
  },
  table: {
    borderColor: 'palette.surface.5',
    borderWidth: '1px',
  },
  title: {
    leftLine: {
      bg: 'palette.primary.40',
      borderRadius: ' 2px',
    },
    subtitle: 'palette.tertiary.40',
  },
};
